import { PrismicNextImage } from '@prismicio/next';
import * as prismicH from '@prismicio/helpers';
import clsx from 'clsx';

import { BaseSlice } from '../../components/BaseSlice';
import { Bounded } from '../../components/Bounded';

const Image = ({ slice, index }) => {
  return (
    <Bounded
      as="section"
      index={index}
      className={clsx(slice.variation === 'white' && 'bg-white')}>
      <BaseSlice>
        {prismicH.isFilled.image(slice.primary.image) && (
          <PrismicNextImage
            field={slice.primary.image}
            sizes="100vw"
            alt={slice.primary.image.alt}
            className="img-fluid rounded"
          />
        )}
      </BaseSlice>
    </Bounded>
  );
};

export default Image;
